// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-different-dates[data-v-41d69161] .modal{max-width:560px;overflow:visible;padding-bottom:4rem;padding-top:4rem}.modal-different-dates[data-v-41d69161] .modal-header{padding-top:0!important}.modal-different-dates .modal-button-wrapper[data-v-41d69161]{display:flex;flex-grow:1;justify-content:center;max-width:12rem;min-width:8rem}.modal-different-dates .modal-button-wrapper[data-v-41d69161] .button{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
